import { render, staticRenderFns } from "./companyTable.vue?vue&type=template&id=14947c76&scoped=true&"
import script from "./companyTable.vue?vue&type=script&lang=js&"
export * from "./companyTable.vue?vue&type=script&lang=js&"
import style0 from "./companyTable.vue?vue&type=style&index=0&id=14947c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14947c76",
  null
  
)

export default component.exports